export const EmployeesPermissions = {
    List: 10000,
    Create: 10001,
    Update: 10002,
    ShowDetails: 10003,
    Delete: 10004,
    LockUnLock: 10005,

}
export const DoctorsPermissions = {
    List: 11000,
    Create: 11001,
    Update: 11002,
    ShowDetails: 11003,
    Delete: 11004,
    LockUnLock: 11005,
    AppointmentsDoctors:11006
}

export const paymentAccountsPermissions = {
    List: 29000,
    Create: 29001,
    Update: 29002,
    ShowDetails: 29003,
    Delete: 29004,
    LockUnLock: 29005,
}
export const AppointmentsDoctorsPermissions = {
    List: 12000,
    Create: 12001,
    Update: 12002,
    ShowDetails: 12003,
    Delete: 12004,
}
export const DepartmentsPermissions = {
    List: 13000,
    Create: 13001,
    Update: 13002,
    Delete: 13004,
}
export const SpecializationsPermissions = {
    List: 14000,
    Create: 14001,
    Update: 14002,
    ShowDetails: 14003,
    Delete: 14004,
}
export const ServicesPermissions = {
    List: 15000,
    Create: 15001,
    Update: 15002,
    ShowDetails: 15003,
    Delete: 15004,
}
export const ReviewReasonsPermissions = {
    List: 16000,
    Create: 16001,
    Update: 16002,
    ShowDetails: 16003,
    Delete: 16004,
}
export const RoomsPermissions = {
    List: 17000,
    Create: 17001,
    Update: 17002,
    ShowDetails: 17003,
    Delete: 17004,
}
export const userPermissions = {
    List: 18000,
    Create: 18001,
    Update: 18002,
    ShowDetails: 18003,
    Delete: 18004,
    LockUnLock: 18005,
    ResetPassword: 18006,
}
export const analysisPermissions = {
    List: 23000,
    Create: 23001,
    Update: 23002,
    ShowDetails: 23003,
    Delete: 23004,
    LockUnLock: 23005,
}
export const doctorsStockPermissions = {
    List: 31000,
    Create: 31001,
    ShowDetails: 31003,
  
}